import React, { useEffect, useState } from "react";
import Button from "../../Components/Button";
import Modal from "../../../../../../components/ui/Modal/Modal";
import SelectInventory from "./SelectInventory";
import ResultTableManual from "./ResultTableManual";
import QuantityTableManual from "./QuantityTableManual";
import { ImArrowRight } from "react-icons/im";
import { useLotDataById } from "../../../../../../api/inventory/use-lot-data";
import dayjs from "dayjs";
import { useUpdateProductLots } from "../../../../../../api/inventory/use-update-lot";

const InventoryChangeModal = ({
  productData,
  prodId,
  currentStockQty,
  onCloseModalAdjust,
  setTriggerCloseModalAdjust,
}) => {
  const { isEmpty, getDataTableProps } = useLotDataById({}, prodId);
  const [selectedQR, setSelectedQR] = useState();
  const [showQR, setShowQR] = useState();
  const [triggerCloseModal, setTriggerCloseModal] = useState(false);
  const [qty, setQty] = useState(0);
  const showedData = getDataTableProps().data?.find((val) => val.id === showQR);
  const { mutate: updateProductLots } = useUpdateProductLots();
  const [operator, setOperator] = useState("+");
  const isSubmitDisable =
    qty === 0 || !qty || (operator === "-" && qty > showedData?.qnt);

  const qtyAfterDelivery =
    operator === "+" ? +showedData?.qnt + +qty : +showedData?.qnt - +qty;

  const currentStockAfterDelivery =
    operator === "+" ? +currentStockQty + +qty : +currentStockQty - +qty;

  const [
    triggerCloseModalSelectInventory,
    setTriggerCloseModalSelectInventory,
  ] = useState(false);

  const [triggerCloseModalInstruction, setTriggerCloseModalInstruction] =
    useState(false);

  useEffect(() => {
    if (triggerCloseModalSelectInventory === true) {
      setTriggerCloseModalSelectInventory(false);
    }
  }, [triggerCloseModalSelectInventory]);

  const onCloseModalSelectInventory = () => {
    setTriggerCloseModalSelectInventory(true);
  };

  useEffect(() => {
    if (triggerCloseModalInstruction === true) {
      setTriggerCloseModalInstruction(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerCloseModalSelectInventory]);

  const onCloseModalInstruction = () => {
    setTriggerCloseModalInstruction(true);
  };

  useEffect(() => {
    if (triggerCloseModal === true) {
      setTriggerCloseModal(false);
    }
  }, [triggerCloseModal]);

  const onSubmitQR = () => {
    setShowQR(selectedQR);
    setTriggerCloseModalSelectInventory(true);
  };

  const onChangeSelectQR = (id) => {
    setSelectedQR(id);
  };

  const onChangeQty = (e) => {
    setQty(e.target.value);
  };

  const onChangeOperator = (val) => {
    if (val === "+") {
      setOperator("+");
    } else {
      setOperator("-");
    }
  };

  const handleSubmit = async () => {
    if (!isSubmitDisable) {
      await updateProductLots({
        id: showedData?.id,
        qnt: qtyAfterDelivery,
        qntType: "ADJUSTMENT",
      });
      setTriggerCloseModal(true);
      setTriggerCloseModalAdjust(true);
    }
  };

  return (
    <div>
      <div className="flex items-center px-6 py-1 justify-between">
        <h1 className="font-bold text-sm">재고 수동 변경</h1>
        <Modal
          hasSubmit={false}
          hasCancel={false}
          maxWidth="max-w-[25rem]"
          description={
            <div className="px-2.5 -my-1">
              <div className="flex justify-end">
                <Button
                  onClick={onCloseModalInstruction}
                  padding="py-0.5"
                  width={`w-20`}
                  titleButton="닫기"
                />
              </div>
              <div>
                <p className="font-bold text-sm mt-2 mb-4">
                  ※ 재고 수동 변경 - 사용 안내
                </p>
                1. 기능 설명 : 등록된 재고를 수정할 수 있는 기능입니다.
                <br />
                2. 사용 방법
                <br />
                (1) '조정 재고 선택' 버튼을 클릭해주세요.
                <br />
                (2) 조정 재고 선택 팝업에서 조정이 필요한 재고정보를 선택하면,
                <br />
                <span className="text-secondary-blue">'적용결과'</span>가
                나옵니다.
                <br />
                (3) 조정을 (+), (-) 항목을 선택 한 다음, 수량을 입력해주세요.
                <br />
                (4) <span className="text-dark-red">'등록 완료'</span> 버튼을
                눌러주세요.
              </div>
            </div>
          }
          triggerClose={triggerCloseModalInstruction}
        >
          <button className="border text-xs px-3 py-1 rounded-[4px]">
            사용 안내
          </button>
        </Modal>
      </div>
      <div className="border-b my-2"></div>
      <div className="px-6 pt-3">
        <div className="w-full px-4 border border-primary-blue bg-primary-blue">
          <p className="text-white py-2">상품정보</p>
        </div>

        <div className="flex w-full">
          <div className="flex w-[50%]">
            <h1
              className={`border py-2 w-28 px-4 border-r-0 border-disable-grey bg-input-grey flex-none`}
            >
              카테고리
            </h1>
            <div className="flex items-center border-disable-grey px-2 outline-none border-r-0 border w-full">
              {productData?.productGroup?.productGroupCategory?.name}
            </div>
          </div>
          <div className="flex w-[50%]">
            <h1 className="border py-2 w-28 px-4 border-r-0 border-disable-grey bg-input-grey flex-none">
              REF(상품코드)
            </h1>
            <div className="flex items-center border-disable-grey px-2 outline-none w-full border">
              {productData?.ref}
            </div>
          </div>
        </div>
        <div className="flex w-full">
          <h1 className="border border-t-0 py-2 w-28 flex-none px-4 border-r-0 border-disable-grey bg-input-grey">
            상품명
          </h1>
          <div className="flex items-center border-disable-grey border-t-0 px-2 outline-none w-full border">
            {productData?.name}
          </div>
        </div>
      </div>

      <div className="px-6 pt-3">
        <div className="w-full px-4 border flex justify-between border-primary-blue bg-primary-blue">
          <p className="text-white py-2">조정 재고정보</p>
          <div className="flex text-white items-center">
            <p className="mr-4">
              ※ 조정 재고를 먼저 선택한 후, 조정 수량을 변경할 수 있습니다.
            </p>
            <Modal
              padding="px-0 py-0"
              description={
                <SelectInventory
                  getDataTableProps={getDataTableProps}
                  isEmpty={isEmpty}
                  onChangeSelectQR={onChangeSelectQR}
                  onSubmitQR={onSubmitQR}
                  selectedQR={selectedQR}
                  onCloseModalSelectInventory={onCloseModalSelectInventory}
                />
              }
              maxWidth="max-w-[47rem]"
              hasSubmit={false}
              hasCancel={false}
              triggerClose={triggerCloseModalSelectInventory}
            >
              <Button
                textColor="text-black"
                padding="py-0.5 px-4"
                width="w-32"
                titleButton="조정 재고 선택"
                backgroundColor="bg-[#FCFCFC]"
                borderColor="border-button-grey"
              />
            </Modal>
          </div>
        </div>
        <table className="min-w-full">
          <thead>
            <tr className="text-center bg-[#F2F2F4]">
              <th className="border py-2 border-disable-grey">LOT</th>
              <th className="border border-disable-grey">QR번호</th>
              <th className="border border-disable-grey">제조일자</th>
              <th className="border border-disable-grey">유효일자</th>
              <th className="border border-disable-grey">재고수량</th>
              <th className="border border-disable-grey">현재 재고수량</th>
            </tr>
          </thead>
          {showedData ? (
            <tbody>
              <tr className="text-center">
                <td className="p-3 border border-[#dddddd]">
                  {showedData?.productLotInfo.lotNo}
                </td>
                <td className="p-3 border border-[#dddddd]">
                  {showedData?.qrNo}
                </td>
                <td className="p-3 border border-[#dddddd]">
                  {dayjs(showedData?.manufacDate).format("YYYY-MM-DD")}
                </td>
                <td className="p-3 border border-[#dddddd]">
                  {dayjs(showedData?.expireDate).format("YYYY-MM-DD")}
                </td>
                <td className="p-3 border border-[#dddddd]">
                  {showedData?.qnt}
                </td>
                <td className="p-3 border border-[#dddddd] font-bold">
                  {currentStockQty}
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td className="border border-disable-grey h-10"></td>
                <td className="border border-disable-grey h-10"></td>
                <td className="border border-disable-grey h-10"></td>
                <td className="border border-disable-grey h-10"></td>
                <td className="border border-disable-grey h-10"></td>
                <td className="border border-disable-grey h-10"></td>
              </tr>
            </tbody>
          )}
        </table>
        <div className={`mt-4 ${showedData ? "h-auto" : "h-[8rem]"}`}>
          <h2 className="text-[14px] font-bold">■ 적용 결과</h2>
          {showedData ? (
            <>
              <div className="flex items-center gap-4 mt-2">
                <div className="w-[40%]">
                  <ResultTableManual
                    qty={qty}
                    currentQty={showedData?.qnt}
                    onChangeQty={onChangeQty}
                    onChangeOperator={onChangeOperator}
                    operator={operator}
                  />
                </div>
                <ImArrowRight className="text-[42px]" />
                <div className="w-[60%]">
                  <QuantityTableManual
                    qtyAfterDelivery={qtyAfterDelivery}
                    currentStockAfterDelivery={currentStockAfterDelivery}
                  />
                </div>
              </div>
              <div className="mt-3">
                ※ (+) 조정, (-) 조정을 선택 후, 수량을 입력해주세요. (-) 조정은
                재고수량 범위내에서만 가능합니다.
              </div>
            </>
          ) : null}
        </div>
      </div>
      <div className="flex border-t border-t-primary-grey mt-10 pt-3 justify-center">
        <Button
          onClick={onCloseModalAdjust}
          textColor="text-black"
          padding="py-1.5 px-4 mr-2"
          width="w-24"
          titleButton="취소"
          backgroundColor="bg-[#FCFCFC]"
          borderColor="border-title-black"
        />
        <Button
          onClick={handleSubmit}
          textColor={`${
            isSubmitDisable ? "text-disable-black" : "text-white"
          } `}
          padding="py-1.5 px-4"
          width="w-24"
          disabled={isSubmitDisable}
          titleButton="등록완료"
          backgroundColor={`${
            isSubmitDisable ? "bg-disable-grey" : "bg-primary-blue"
          } `}
          borderColor="border-border-grey"
        />
      </div>
    </div>
  );
};

export default InventoryChangeModal;
